<li [ngClass]="{'active': active.id === chapter.id}" role="menuitem">
  <a (click)="onChapterClicked(chapter.id)" (keyup.enter)="onChapterClicked(chapter.id)" role="link" tabindex="0">{{ chapter.name }}</a>
  <ul *ngIf="chapter.children?.length > 0">
    <app-content-nav-chapter *ngFor="let subchapter of chapter.children" [chapter]="subchapter" [active]="active" (clicked)="onChapterClicked($event)"></app-content-nav-chapter>
  </ul>
</li>
